module.exports = "<gw-definition-list\r\n        title=\"{{ 'gateway.contacts.components.ContactDetails.Roles.Account Holder.Title' | translate }}\"\r\n></gw-definition-list>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleAccountHolder/ContactRoleAccountHolder.html
// module id = 697
// module chunks = 0